// new Date("Jun 2,2017 12:00:00"); //Fri Jun 02 2017 12:00:00 GMT+0800 (中国标准时间)
// 　new Date("Jun 2,2017"); //Fri Jun 02 2017 00:00:00 GMT+0800 (中国标准时间)
// 　new Date(2017,5,2,12,0,0); //Fri Jun 02 2017 12:00:00 GMT+0800 (中国标准时间)
// 　new Date(2017,5,2); //Fri Jun 02 2017 00:00:00 GMT+0800 (中国标准时间)
// 　new Date(1496376000000); //Fri Jun 02 2017 12:00:00 GMT+0800 (中国标准时间)
//new Date(2017,5,2).gettime()得到的也是时间戳

// 时间戳转化为日期
function isAddZero(time) {
    let str = ''
    str = time < 10 ? '0' + time : time.toString()
    return str
}
export default function getTime(time) {
    const date = new Date(time * 1000);
    const Y = date.getFullYear();
    const M = isAddZero(date.getMonth() + 1);
    const D = isAddZero(date.getDate());
    return `${Y}-${M}-${D}`;
}

// 通过中国标准时间获取几十几分
export function newDate(time) {
    var date = new Date(time)
    var y = date.getFullYear()
    var m = date.getMonth() + 1
    m = m < 10 ? '0' + m : m
    var d = date.getDate()
    d = d < 10 ? '0' + d : d
    var h = date.getHours()
    h = h < 10 ? '0' + h : h
    var minute = date.getMinutes()
    minute = minute < 10 ? '0' + minute : minute
    var s = date.getSeconds()
    s = s < 10 ? '0' + s : s
    return h + ':' + minute;
}

// 将中国标准时间转换为时间戳